(function($, Drupal) {
  Drupal.behaviors.quote_info_blocks = {
    attach: function(context, settings) {
      // Image scroller, basic functionality
      let $image_scrollers;

      $image_scrollers = $('.image-scroller');

      $image_scrollers.once('set-scroller').each(function(i) {
        let $image_scroller = $(this);

        $image_scroller.once('intialize-scroller').each(function() {
          let $images = $image_scroller.find('.media--type-image');
          $images.first().addClass('active');

          let $prev_button = $image_scroller.find('.prev').first();
          let $next_button = $image_scroller.find('.next').last();
          let $counter = $image_scroller.find('.counter-start').first();

          $prev_button.on('click', function() {
            if ($image_scroller.find('.active').prev('.media--type-image').length !== 0) {
              $image_scroller.find('.active').removeClass('active').prev('.media--type-image').addClass('active');
              $counter.text($image_scroller.find('.active').index() + 1);
            }
            else {
              $image_scroller.find('.active').removeClass('active');
              $image_scroller.find('.media--type-image').last().addClass('active');
              $counter.text($image_scroller.find('.active').index() + 1);
            }
          });

          $next_button.on('click', function() {
            if ($image_scroller.find('.active').next('.media--type-image').length !== 0) {
              $image_scroller.find('.active').removeClass('active').next('.media--type-image').addClass('active');
              $counter.text($image_scroller.find('.active').index() + 1);
            }
            else {
              $counter.text(1);
              $image_scroller.find('.active').removeClass('active');
              $image_scroller.find('.media--type-image').first().addClass('active');
            }
          });
        });
      });

      // Create anchor nav
      let $block_headings,
          $block_headers,
          $block_header_text,
          $block_id;

      $block_headings = $('.field--name-field-quote-block-title');
      $block_headings.once('create-ids').each(function() {
        $(this).parent().attr('id', $(this).text().toLowerCase().replace(',', '').replace(/ /g, '-'));
      });


      $('.field--name-field-info-blocks').once('link-anchors').each(function(index) {
        $block_headers = $(this).find('.quote-info__header');
        $(this).prepend('<ul id="anchor-links-' + index + '"></ul>');

        $block_headers.once('inject-links').each(function() {
          $block_header_text = $(this).find('.field--name-field-quote-block-title').text();
          $block_id = $(this).attr('id');
          $('#anchor-links-' + index).append('<li><a href="#' + $block_id + '">' + $block_header_text + '</a></li>');
        });
      });
    }
  };
})(jQuery, Drupal);
